import axios from "axios";
const checkEnvironment = (url, apiUrl) => {
  const Environment = process.env.NODE_ENV;
  if (Environment === "development") return url + apiUrl;
  if (Environment === "production")
    return window.env.REACT_APP_API_HOST + apiUrl;
};
const _basic = window.env.REACT_APP_API_DEVELOPMENT_HOST;
const _storeBaseUrl = "/Customer/Store";
const _staffBaseUrl = "/Customer/Country";


const store = axios.create({
  baseURL: checkEnvironment(_basic, _storeBaseUrl)
});

const staff = axios.create({
  baseURL: checkEnvironment(_basic, _staffBaseUrl)
});



/**
 * @param {number} langId
 */
export const getAllStore = async langId => {
  return await store.get("/GetStoreAll", { params: { languageID: langId } });
};

/**
 *
 * @param {number} storeId
 */
export const getGroup = async storeId => {
  return await staff.get("/GetCustomerGroup", { params: { storeID: storeId } });
};

/**
 *
 * @param {number} groupId
 */
export const getStaff = async groupId => {
  return await staff.get("/GetCustomerWaiter", {
    params: { groupID: groupId }
  });
};

/**
 * @param {number} staffId
 * @param {number} storeId
 * @param {number} LangId
 */
export const getTranslationStaffInfo = async (staffId, storeId, LangId) => {
  return await staff.get("/TranslationWaiter", {
    params: {
      waiterID: staffId,
      storeID: storeId,
      languageID: LangId
    }
  });
};

/**
 * @param {number} storeId
 */
export const getStoreAllStaff = async (storeId) => {
  return await staff.get("/GetStoreWaiter", {
    params: {
      storeID: storeId
    }
  });
};

/**
 * @param {number} workNum
 */
export const getStaffInfo = async (workNum) => {
  return await staff.get("/GetWaiterInfo", {
    params: {
      work_num: workNum
    }
  });
};

/**
 * @param {object} staffInfo
 */
export const postSetSupport = async staffInfo => {
  return await staff.post("/SetWaiterSupportGroup", staffInfo);
};